import React, { useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { CloneIcone, CircleCross } from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import { setErrorAlert } from 'AppSrc/core/actions/actions-error-alert';
import { Loader } from 'AppSrc/core/components/utility/loader';
import { submitAndUpdateCloneCreateCrqForm } from 'AppSrc/core/actions/actions-create-crq-form';
import { LoadingSpinner } from 'AppSrc/core/components/utility/loading-spinner';
import {
  clearEditSectionsRead,
  fetchCrqForViewEdit,
} from 'AppSrc/core/actions/actions-edit-form';
import { CRQ_STATUS_TRANSITIONS } from 'AppSrc/core/crq/crq-status-transitions';
import { ES_VIEWING_NEW_SECTION } from 'AppSrc/core/components/forms/form-base-components/data-structure/constants';
import { listTableRowPropShape } from './table-proptypes';
import { CloneSummary } from '../view-crq-screen/view-crq-clone-summary';
import { InfoIconClone, InfoIconEmergency } from '../forms/form-types/create-crq/section-change-request-summary/info-icon';


const DuplicateRowMenuUnconnected = ({
  id,
  rows,
  // formData,
  key,
}) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const [crqIdCurrentRow, setCrqIdCurrentRow] = useState('');
  const [rowCrqId, setRowCrqId] = useState(null);
  const [networkClone, setNetworkClone] = useState(null);
  const [cloneCrqId, setClonCrqId] = useState(null);

  const history = useHistory();
  const dispatch = useDispatch();

  const openRowMenu = () => {
    setOpenMenu(!openMenu);
    setCrqIdCurrentRow(id);
  };

  const fetchCrqForDupliate = (network, crqId) => {
    dispatch(fetchCrqForViewEdit({
      editingStatus: ES_VIEWING_NEW_SECTION,
      crqId,
      network,
    }));
    // deleteAllDataForForm(formId);
  };

  const openModalClone = () => {
    // setCrqIdCurrentRow(id);
    const clickedData = crqIdCurrentRow ? crqIdCurrentRow.split('/') : '';
    const [network, crqId] = clickedData;
    setIsLoading(true);
    if (crqIdCurrentRow !== '') {
      fetchCrqForDupliate(network, crqId);
      setNetworkClone(network);
      setRowCrqId(crqId);
    }
    setTimeout(() => {
      setOpenModal(!openModal);
      setIsLoading(false);
    }, 2000);
    // return true;
  };

  const createCloneCRQHandle = () => {
    // pass the required status to the submit actions
    setIsLoader(!isLoader);
    dispatch(submitAndUpdateCloneCreateCrqForm(CRQ_STATUS_TRANSITIONS.raiseCrq, rowCrqId))
      .then((response) => {
        console.log('create clone crq', response);
        setClonCrqId(response);
        setIsLoader(false);

        dispatch(clearEditSectionsRead(rowCrqId));
        // navigate to the success route, with the correct crqId
        // const successPath = CRQ_TRANSITION_CONFIRMATION.getPath({ network, crqId, transitionId });
        history.push(`/crq/${networkClone}/${response}`);
        // {`crq/${network}/${cloneCrqId}`}
        //  // clear all the form data
        //  dispatch(deleteAllDataForForm(CREATE_CRQ));
        //  // To delete individual approver list
        //  dispatch(deleteAllIndidualList());
      })
      .catch((error) => {
        dispatch(setErrorAlert({
          errorTitle: 'Sorry we are unable to create your CRQ due to a technical issue. Please try again later.',
          errorText: 'Please try to refresh or try again later',
        }));
        console.warn(error);
      });
  };

  const handleCloseClick = () => {
    setOpenModal(!openModal);
    setOpenMenu(!openMenu);
  };

  const loaderArray = [true, false];
  const clickedData = crqIdCurrentRow ? crqIdCurrentRow.split('/') : '';
  const [network] = clickedData;
  const slaType = rows[3].props.children;
  const isEmergeny = slaType === 'Emergency' ? true : false;
  return (
    <div className="outer-row-features">
      <button
        type="button"
        onClick={openRowMenu}
        title="Create Duplicate CRQ"
      >
        {!openMenu ? <CloneIcone /> : <CircleCross /> }
      </button>
      {
        openMenu ? (
          <div className="iner-row-features">
            <button
              onClick={openModalClone}
              type="button"
            >
              Duplicate
            </button>
          </div>
        ) : null
      }
      {
        isLoading ? (
          <Loader
            loaderArray={loaderArray}
            loaderTitle="Please wait whilst we load the CRQ"
            loaderText="Do not close or refresh your browser whilst we do this."
          />
        ) : null
      }
      {
        openModal ? (
          <ModalPortal>
            <div
              className="v-f-modal-section cancel-crq-modal"
            >
              <div className="v-f-modal-shadow" />
              <div className="v-f-modal-inner">
                <div className="cancel-crq-modal-content clone-crq-summary">
                  {
                    cloneCrqId !== null ? (
                      <div className="copy-clipboard">
                        <h4>CRQ Created Successfully</h4>
                        <button
                          type="button"
                          title="Copy to clipboard"
                          onClick={() => window.navigator.clipboard.writeText(cloneCrqId)}
                        >
                          <Link to={`crq/${network}/${cloneCrqId}`}>{cloneCrqId}</Link>
                          <CloneIcone />
                        </button>
                      </div>
                    ) : null
                  }
                  <div className="headText">
                    <h3>
                      CRQ Summary
                    </h3>
                  </div>
                  <InfoIconClone />
                  {
                  isEmergeny && network !== 'mobile' ? (
                    <InfoIconEmergency />
                  ) : null
                  }
                  <CloneSummary
                    crqId={rowCrqId}
                  />
                  {
                    cloneCrqId !== null ? (
                      <div className="copy-clipboard">
                        <h4>CRQ Created Successfully</h4>
                        <button
                          type="button"
                          title="Copy to clipboard"
                          onClick={() => window.navigator.clipboard.writeText(cloneCrqId)}
                        >
                          <Link to={`crq/${network}/${cloneCrqId}`}>{cloneCrqId}</Link>
                          <CloneIcone />
                        </button>
                      </div>
                    ) : null
                  }
                  <div className="form-modal-options form-modal-options-space-maker" />
                  <div className="form-modal-options">
                    <div className="side-left">
                      <button
                        type="button"
                        className="cancel-button"
                        onClick={handleCloseClick}
                      >
                        Back
                      </button>
                    </div>
                    <div className="side-right">
                      {
                        isLoader === true
                          ? <LoadingSpinner />
                          : (
                            <button
                              type="button"
                              className="save-button save-button-ready"
                              // className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                              // disabled={!readyToSubmit}
                              onClick={createCloneCRQHandle}
                            >
                              Create Duplicate CRQ
                            </button>
                          )

                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalPortal>
        ) : null
      }
    </div>
  );
};



// RowMenu.propTypes = {
//   id: PropTypes.string,
//   key: PropTypes.string,
//   // columns: PropTypes.arrayOf(listTableColumnPropShape),
//   rows: PropTypes.arrayOf(listTableRowPropShape),
//   // onClickRow: PropTypes.func,
//   // className: PropTypes.string,
//   // noResultsMessage: PropTypes.string,
//   // ...sortProps,
// };

DuplicateRowMenuUnconnected.propTypes = {
  id: PropTypes.string,
  key: PropTypes.string,
  // formData: formDataFromServerShape,
  rows: PropTypes.arrayOf(listTableRowPropShape),
  // remedyIds: PropTypes.objectOf(PropTypes.string),
  // userRoles: PropTypes.objectOf(PropTypes.string),
  // fetchCrq: PropTypes.func,
  // errorAlert: PropTypes.func,
  // summarySectionsRead: PropTypes.objectOf(PropTypes.bool),
  // fetching: PropTypes.bool,
  // isChangeAnalyst: PropTypes.bool, // changeAnalyst PropTypes validation
};

// const mapStateToProps = (state, ownProps) => {
//   // const clickedData = ownProps.id ? ownProps.id.split('/') : '';
//   // const [network, crqId] = clickedData;
//   // const formData = state.editForm.formDataById[crqId];
//   // console.log('FORMDATA', formData);
//   // const summarySectionsRead = (formData && formData.summarySectionsRead) ? formData.summarySectionsRead : {};
//   // const fetching = state.editForm.fetchingById[crqId] ? true : false;
//   // const isChangeAnalyst = state && state.auth.isChangeAnalyst; // Fetching if the user is changeAnalyst or not
//   // console.log('header formData', formData, crqId, state.editForm);
//   return ({
//     // formData,
//     // network,
//     // remedyIds: state.auth.user.remedyIds,
//     // userRoles: state.auth.user.roles,
//     // summarySectionsRead,
//     // fetching,
//     // isChangeAnalyst,
//   });
// };

const DuplicateRowMenu = connect(
  null,
)(DuplicateRowMenuUnconnected);
export { DuplicateRowMenu };

